import axios, { AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'
import {
  IBackendAnswer,
  IQuestionV2,
  MainObject,
  triageLevelStates,
} from '../../store/reports/types'
import reportsUrls from '../../utils/urls/reportsUrls'
const BASE_URL = process.env.REACT_APP_BACKEND_URL

const getAllRequiresTriage = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getReportsRequiresTriage())

const getUsersReports = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getUsersReports())

const getAdminReports = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getAdminReports())

const getCaseById = async (caseId: number) => {
  const { data } = await axiosInstance.get(`${reportsUrls.getReportById(caseId)}?fetch=all`)
  return data
}

const getResolvedDataFromReport = async (caseId: number) => {
  const { data } = await axiosInstance.get(`${reportsUrls.getResolvedReportsUrl()}?report_id=${caseId}`)
  return data
}

const getReportAnswers = (reportId: number): Promise<AxiosResponse<IBackendAnswer[]>> =>
  axiosInstance.get(reportsUrls.getReportAnswers(reportId))

const getCaseTypeQuestions = ({
  caseType,
  caseId,
}: {
  caseType: string
  caseId: string
}): Promise<AxiosResponse<IQuestionV2[]>> =>
  axiosInstance.get(reportsUrls.getCaseTypeQuestions({ caseType, caseId }))

const postTriageLevel = ({
  selectedReportId,
  dataBody,
  actionType = 'assign',
  triage_level = '',
}: {
  selectedReportId: number
  dataBody: any
  actionType?: string
  triage_level?: string
}): Promise<AxiosResponse> =>
  axiosInstance.post(
    reportsUrls.postTriageLevel(selectedReportId, actionType),
    {
      ...dataBody,
    },
    {
      params: {
        ...(triage_level === triageLevelStates.TRANSFERED_FOR_ASSIGNMENT ||
        triage_level === triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED
          ? { triage: triage_level }
          : {}),
      },
    },
  )
const patchReport = ({
  selectedReportId,
  dataBody,
}: {
  selectedReportId: number
  dataBody: any
}): Promise<AxiosResponse> =>
  axiosInstance.patch(reportsUrls.getReportById(selectedReportId), {
    ...dataBody,
  })

const getArchivedReports = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getReportsArchived())

const getTeamMembers = (id: number): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getTeamMembersUrl(id))

const getReportTypes = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getReportTypesUrl())

const postAnswersToCaseTypeQuestions = (
  reportId: number,
  answers: any,
  report_type: string,
): Promise<AxiosResponse> =>{
  // console.log(answers)
  return axiosInstance.post(`${reportsUrls.getReportById(reportId)}answers`, answers, {
    params: {
      report_type,
    },
  })
}
const getAnswersToCaseTypeQuestions = (
  reportId: number,
  report_type: string,
): Promise<AxiosResponse> =>
  axiosInstance.get(`${reportsUrls.getReportById(reportId)}answers/`, {
    params: {
      report_type,
    },
  })

const patchAnswers = (reportId: number, answers: MainObject[]): Promise<AxiosResponse> =>
  axiosInstance.patch(`${reportsUrls.getReportById(reportId)}answers`, answers)

const postCaseStatusMessage = (data: any): Promise<AxiosResponse> =>
  axiosInstance.post(`${reportsUrls.getStatusMessageUrl()}/`, data)

const getCaseStatusMessages = (reportID: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${reportsUrls.getStatusMessageUrl()}?report=${reportID}`)

const getMetricsFiltered = (filter: any): Promise<AxiosResponse> =>
  axiosInstance.post(`${BASE_URL}metrics`, filter)

const getAllOutcomes = (): Promise<AxiosResponse> => axiosInstance.get(reportsUrls.getOutcomesUrl())
const getAllDispositions = (): Promise<AxiosResponse> =>
  axiosInstance.get(reportsUrls.getDispositionsUrl())

const postResolvedReport = (data: any): Promise<AxiosResponse> =>
  axiosInstance.post(reportsUrls.getResolvedReportsUrl(), data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

const getExportReports = (data: any): Promise<AxiosResponse> => {
  return axiosInstance.get(`${BASE_URL}export`, { params: data })
}

const getReportExport = (reportId: number, export_as: string): Promise<AxiosResponse> => {
  if (export_as === 'csv')
    return axiosInstance.get(`${reportsUrls.getReportById(reportId)}export?export_as=${export_as}`)
  else if (export_as === 'zip')
    return axiosInstance.get(`${BASE_URL}export-report?export_as=${export_as}&report=${reportId}`)
  else return axiosInstance.get(`${reportsUrls.getReportById(reportId)}export?as=${export_as}`)
}

export default {
  getAllRequiresTriage,
  getCaseById,
  getResolvedDataFromReport,
  getReportAnswers,
  getCaseTypeQuestions,
  postTriageLevel,
  patchReport,
  getUsersReports,
  getAdminReports,
  getArchivedReports,
  getTeamMembers,
  getReportTypes,
  postAnswersToCaseTypeQuestions,
  getAnswersToCaseTypeQuestions,
  patchAnswers,
  postCaseStatusMessage,
  getCaseStatusMessages,
  getMetricsFiltered,
  getAllOutcomes,
  getAllDispositions,
  postResolvedReport,
  getExportReports,
  getReportExport,
}
